import React from 'react';
import { Participant as IParticipant } from 'twilio-video';
import ParticipantTracks from '../ParticipantTracks/ParticipantTracks';

interface ParticipantProps {
    participant: IParticipant;
    videoOnly?: boolean;
    enableScreenShare?: boolean;
    isLocalParticipant?: boolean;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default function Participant({
    participant,
    videoOnly,
    enableScreenShare,
    isLocalParticipant,
}: ParticipantProps) {
    return (
        <ParticipantTracks
            participant={participant}
            videoOnly={videoOnly}
            enableScreenShare={enableScreenShare}
            isLocalParticipant={isLocalParticipant}
        />
    );
}
